/**
 * @file faqs.ts
 * @path apps/website/src/data/faqs.ts
 * @description
 */

// src/data/faqs.ts

import { FaqItem } from "@sirbastians/types";

// An array containing all the FAQ data
export const faqs: FaqItem[] = [
  {
    id: "faq-1",
    question: "How do I book a service with Sir Bastian's?",
    answer:
      "You can easily request a booking by filling out the form on our booking page, or by sending us an email with your trip details. For custom tours or urgent requests, feel free to give us a call directly. We'll confirm your reservation and details via email.",
  },
  {
    id: "faq-2",
    question: "What types of services do you offer?",
    answer:
      "We specialize in a range of premium transport solutions, including reliable airport transfers, private point-to-point shuttles, full-day scenic tours like the Cape Peninsula and Winelands, as well as custom private hires for corporate events or special occasions.",
  },
  {
    id: "faq-3",
    question: "Where do you pick me up for an airport transfer?",
    answer:
      "For arrivals at Cape Town International Airport, our driver will meet you with a personalized name board at the designated chauffeur meeting point just after you exit the baggage claim area. We track your flight to ensure we are there on time, even if your flight is delayed.",
  },
  {
    id: "faq-4",
    question: "What is your cancellation policy?",
    answer:
      "We understand that plans can change. We offer a full refund for cancellations made at least 24 hours before the scheduled pickup time. Cancellations made within 24 hours of the scheduled pickup time will result in a 100% payment being charged. Please contact us as soon as possible to modify your booking.",
  },
  {
    id: "faq-5",
    question: "Are the prices per person or per vehicle?",
    answer:
      "Our pricing varies by experience. Airport transfers and private hires are typically priced per vehicle, while our curated tours are often priced per person. The price for each service is clearly indicated, and we are happy to provide a detailed quote for any custom requests.",
  },
  {
    id: "faq-6",
    question: "Can I create a custom tour itinerary?",
    answer:
      "Absolutely! Our 'Custom Private Hire' service is designed for this. You can hire a vehicle and a professional driver for a half-day or full-day to explore the destinations of your choice at your own pace. We can also help you craft the perfect itinerary based on your interests.",
  },
  {
    id: "faq-7",
    question: "What kind of vehicles are in your fleet?",
    answer:
      "Our fleet consists of modern, clean, and well-maintained vehicles to ensure your comfort and safety. We typically use luxury sedans and spacious minivans, all equipped with air conditioning and complimentary bottled water.",
  },
  {
    id: "faq-8",
    question:
      "Are park entry fees and wine tasting fees included in your tour prices?",
    answer:
      "Our tour prices always cover the private vehicle, driver/guide, fuel, and tolls, and generally include parking fees. For our private tours priced per person, the rate also includes standard wine tasting fees and entry fees to popular attractions like Cape Point and Boulders Beach. For other services or custom hires, these third-party costs are typically excluded to provide maximum flexibility.",
  },
];
